import script from "./PatientIntakeClinicalReview.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientIntakeClinicalReview.vue?vue&type=script&setup=true&lang=js"

import "./PatientIntakeClinicalReview.vue?vue&type=style&index=0&id=18958401&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18958401"]])

export default __exports__